import {
  GET_YUSA_OVERNIGHT_CAMP_YEAR_LIST,
  GET_YUSA_OVERNIGHT_CAMP_ASSOCIATION_LIST
} from '@config/api-config';
import { asyncRequest } from '@config/http-config';
import * as types from './types';

export const getOvernightCampAssociationList = year => (dispatch, getState) =>
  asyncRequest({
    url: GET_YUSA_OVERNIGHT_CAMP_ASSOCIATION_LIST(year),
    successAction: data => ({
      type: types.OVERNIGHT_CAMP_ASSOCIATION_LIST_SUCCESS,
      async: true,
      payload: data,
      state: getState()
    }),
    failureAction: error => ({
      type: types.OVERNIGHT_CAMP_ASSOCIATION_LIST_FAILURE,
      payload: error
    }),
    dispatch
  });

export const getOvernightCampYearList = () => (dispatch, getState) =>
  asyncRequest({
    url: GET_YUSA_OVERNIGHT_CAMP_YEAR_LIST(),
    successAction: data => ({
      type: types.OVERNIGHT_CAMP_YEAR_LIST_SUCCESS,
      async: true,
      payload: data,
      state: getState()
    }),
    failureAction: error => ({
      type: types.OVERNIGHT_CAMP_YEAR_LIST_FAILURE,
      payload: error
    }),
    dispatch
  });
